import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { FixturePage } from '@cds/betting-offer';
import { LiveNavigationConfig, Sitecore } from '@frontend/sports/common/client-config-data-access';
import { AdaptiveLayoutState, ColumnLayoutService } from '@frontend/sports/layout/feature';
import { UrlHelperService } from '@frontend/sports/navigation/core/feature/url-helper';

import { LiveSubnavTabs, createSubnavTabs } from '../event-list/navigation/live-subnavigation.models';
import { SubNavigationResolve } from '../sub-navigation/sub-navigation-resolve.service';
import { SubNavigationItem } from '../sub-navigation/sub-navigation.models';

@Injectable()
export class LiveOverviewSubNavigationResolve extends SubNavigationResolve<FixturePage> {
    constructor(
        private layoutManager: ColumnLayoutService,
        private liveNavConfig: LiveNavigationConfig,
        private sitecore: Sitecore,
        private urlHelperService: UrlHelperService,
    ) {
        super();
        this.tabs$.next(this.getDefaultTabs());
    }

    buildSubNavigation(layout: AdaptiveLayoutState, routeSnapshot: ActivatedRouteSnapshot, model: FixturePage): void {
        if (!this.liveNavConfig.isLiveEventsNavigationEnabled || this.layoutManager.layout.maxColumnCount < 3) {
            this.tabs$.next([]);

            return;
        }

        this.tabs$.next(this.getDefaultTabs());
    }

    private getDefaultTabs(): SubNavigationItem[] {
        return createSubnavTabs(this.urlHelperService, this.sitecore, LiveSubnavTabs.Overview);
    }
}
